import { z } from 'zod';
import { FlowBlockValueFieldSchemaV2, FlowBlockValueFieldSchemaVariant } from './fieldSchema.js';
import { FlowBlockValueTemplateHint, validateFlowBlockValueTemplate } from './template.js';
/**
 * @arg value - A string that is expected to be a number.
 * @returns The number value of the string.
 * @throws {RangeError} If the string is not a valid number.
 * FIXME: Empty string should not be parsed as a number.
 * https://app.asana.com/1/1187495389489253/project/1211038721907666/task/1211185023182384?focus=true
 */
export function parseAsNumber(value) {
    const numberValue = Number(value);
    if (Number.isNaN(numberValue)) {
        throw new RangeError('Invalid number.');
    }
    return numberValue;
}
/**
 * @arg numberValidationSchema - User supplied zod number schema that is checked if value is not a block
 * value template. e.g. `z.number().min(0).max(100)`
 * @returns A Zod schema for validating values that are either block value templates or some zod number type;
 * The returned schema validates that value can parse into number using {@link parseAsNumber}, but only returns
 * the original input string value.
 */
export function FlowBlockValueNumberSchema(args) {
    return z.coerce.string().superRefine((stringValue, context) => {
        const templateParseResult = FlowBlockValueFieldSchemaV2({
            variant: FlowBlockValueFieldSchemaVariant.TemplateOnly,
        }).safeParse(stringValue);
        if (templateParseResult.success) {
            return;
        }
        // We want to validate against string schema only if string is not template-like
        const templateValidation = validateFlowBlockValueTemplate(stringValue);
        if (templateValidation.hint !== FlowBlockValueTemplateHint.NotTemplateLike) {
            templateParseResult.error.issues.forEach((issue) => {
                context.addIssue(issue);
            });
            return;
        }
        let numberValue;
        try {
            numberValue = parseAsNumber(stringValue);
            const numberParseResult = args.numberValidationSchema.safeParse(numberValue);
            if (numberParseResult.success) {
                return;
            }
            numberParseResult.error.issues.forEach((issue) => {
                context.addIssue(issue);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                context.addIssue({
                    code: 'custom',
                    message: error.message,
                });
            }
        }
        templateParseResult.error.issues.forEach((issue) => {
            context.addIssue(issue);
        });
    });
}
//# sourceMappingURL=numberSchema.js.map